export default [
    {
        path: 'relatorio-exame-status',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-relatorio-exame-status' */
            '@/views/exame-imagem/relatorio-exame-status/Index'),
        redirect: 'relatorio-exame-status/index',
        children: [
            {
                name: 'exame-imagem-relatorio-exame-status-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-relatorio-exame-status' */
                    '@/views/exame-imagem/relatorio-exame-status/List.vue'),
            },
        ],
    },
]